import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Footer = () => {
  const location = useLocation();
  const isLoginPage = location.pathname === '/login-screen';

  if (isLoginPage) {
    return null;
  }
     {/* Footer Information */}
  return (
     <div className="mt-12 pt-8 border-t border-border">
     <div className="text-center">
       <div className="flex items-center justify-center space-x-2 mb-2">
         <img src="assets/images/sarvaDharma-logo.png" alt="Logo" className="w-10 h-10" />
         <span className="font-heading font-medium text-foreground">
           Tamil Nadu Prasanthi Seva
         </span>
       </div>
       <p className="text-sm text-muted-foreground mb-4">
         Serving with Love • Dedicated to Sathya Sai Baba's Mission
       </p>
       <div className="flex items-center justify-center space-x-6 text-xs text-muted-foreground">
         <span>© {new Date().getFullYear()} Tamil Nadu Prasanthi Seva</span>
         {/* <span>•</span>
         <span>Version 2.1.0</span> */}
         <span>•</span>
         <span>All Rights Reserved</span>
       </div>
     </div>
   </div>
  );
};

export default Footer;